<template lang="pug">
  aside.sidebar
    .sidebar__inner
      .sidebar-widgets
        .sidebar-widget
          h2 CONTACT
          h3 お問い合わせ
          p 参考サイトを見て
          ul
            li
              strong サイトの方向性
              |がわからなかった方
            li
              |実際に作る際の
              strong 費用感
              |が知りたい方
            li
              |機能が
              strong 実装可能か
              |知りたい方
          p は下記からご相談ください。
          router-link(:to="'/design-base/inquiry'") お問い合わせはこちら
          //- p: span まずはお気軽にご相談ください。
            
</template>

<script>
export default{
}
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";

.sidebar{
  padding: 32px;
  background: #ccc;
  @media only screen and( max-width: $tablet){
    display:none;
  }
  &__inner{
    width: 320px;
    margin: 140px auto 0;
    position: sticky;
    top: 172px;
    z-index: 1;
  }
  &-widgets{
  }
  &-widget{
    margin-bottom: $space-m;
    padding: 24px;
    background: #fff;
    box-shadow:0px 0px 5px 1px rgba(0,0,0, 0.1);
    text-align: left;
    & > h2{
      margin-bottom: $space-m;
      font-size: $font-xs;
      font-weight: bold;
      font-family: 'Lato', sans-serif;
      letter-spacing: .1rem;
      &:after{
        display: block;
        content: '';
        width: 50px;
        height: 3px;
        margin-top: $space-m;
        background: $bg-secondary;
      }
    }
    & > h3{
      margin-bottom: $space-m;
      font-size: $font-xxs;
      font-weight: bold;
    }
    & > ul{
      margin-bottom: $space-s;
      margin-left: $space-m;
      list-style: disc;
      & > li {
        margin-bottom: $space-xs;
        line-height: 1.5;
        font-size: 12px;
        & > strong{
          font-weight: bold;
        }
      }
    }
    a{
      width: 100%;
      margin-top: $space-m;
      padding: 16px 0;
      border-radius: 100px;
      background: #32b1b1;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      display: block;
      text-align: center;
      text-decoration: none;
      
    }
    p{
      margin-bottom: $space-s;
      font-size: 12px;
      span{
        padding: 6px 0;
        border-bottom: 2px solid #32b1b1;
      }
      
    }
  }
}

</style>